import axios from "axios";
import { Label, LabelId } from "../tickets";
import { makeConfigApi } from "./makeConfigApi";

export type LabelConfigurationId = string & { __brand: "LabelConfigurationId" };
export type LabelConfiguration = {
    id: LabelConfigurationId;
    name: string;
    labels: Label[];
};
export type LabelEditModel = {
    name: string;
};
export type LabelCreateModel = {
    names: LabelEditModel[];
};

export type LabelApi = {
    getLabelConfigurations(): Promise<LabelConfiguration[]>;
    createLabelConfiguration(name: string): Promise<LabelConfiguration>;
    editLabelConfiguration(config: LabelConfigurationId, name: string): Promise<void>;
    deleteLabelConfiguration(config: LabelConfigurationId): Promise<void>;

    createLabels(config: LabelConfigurationId, model: LabelCreateModel): Promise<Label[]>;
    editLabel(config: LabelConfigurationId, label: LabelId, name: string): Promise<void>;
    deleteLabel(config: LabelConfigurationId, label: LabelId): Promise<void>;
};

const configApi = makeConfigApi<LabelConfiguration>("labels");

export const labelApi: LabelApi = {
    getLabelConfigurations: configApi.list,
    createLabelConfiguration: configApi.create,
    editLabelConfiguration: configApi.edit,
    deleteLabelConfiguration: configApi.remove,

    async createLabels(config, model) {
        const { data: label } = await axios.post<Label[]>(
            `/api/v0/project-configurations/labels/${config}/labels`,
            model
        );
        return label;
    },
    async editLabel(config, label, name) {
        await axios.post(`/api/v0/project-configurations/labels/${config}/labels/${label}`, {
            name,
        });
    },
    async deleteLabel(config, label) {
        await axios.delete(`/api/v0/project-configurations/labels/${config}/labels/${label}`);
    },
};
